import React, { useState } from 'react';

const EXPECTED = {
  expenseType: 'Travel',
  amount: '2847.50',
  currency: 'USD',
  date: '2026-03-28',
  projectCode: 'PRJ-2024-Q1',
  billable: true,
  reimbursable: true,
  receiptAttached: false,
  notes: 'Flight and hotel for Austin client visit',
  priority: 'High',
};

function Chk({ name, label, checked, onChange, disabled }) {
  return (
    <label className="ab-chk-label">
      <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
      {label}
    </label>
  );
}

export default function C03_ExpenseForm({ onComplete }) {
  const [form, setForm] = useState({
    expenseType: 'Meals', amount: '', currency: 'INR', date: '',
    projectCode: '', billable: false, reimbursable: false, receiptAttached: false,
    notes: '', priority: 'Medium',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const ch = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(e => ({ ...e, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.amount) errs.amount = 'Required';
    if (!form.date) errs.date = 'Required';
    if (!form.projectCode.trim()) errs.projectCode = 'Required';
    if (!form.notes.trim()) errs.notes = 'Required';
    return errs;
  };

  const handleSubmit = () => {
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitted(true);
    const results = {};
    let score = 0;
    for (const key of Object.keys(EXPECTED)) {
      const exp = EXPECTED[key];
      const got = key === 'amount' ? parseFloat(form[key]).toFixed(2) : form[key];
      const expNorm = key === 'amount' ? String(exp) : exp;
      const gotNorm = typeof got === 'boolean' ? got : String(got);
      const pass = gotNorm === (typeof expNorm === 'boolean' ? expNorm : String(expNorm));
      results[key] = { expected: String(exp), got: String(form[key]), pass };
      if (pass) score++;
    }
    const pct = Math.round((score / Object.keys(EXPECTED).length) * 100);
    onComplete({ score: pct, details: results, passed: pct === 100 });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-form-grid-2">
        <div className="ab-field">
          <label className="ab-label">Expense Type</label>
          <select name="expenseType" value={form.expenseType} onChange={ch} className="ab-input" disabled={submitted}>
            {['Meals', 'Travel', 'Accommodation', 'Equipment', 'Software', 'Training', 'Other'].map(v => <option key={v}>{v}</option>)}
          </select>
        </div>
        <div className="ab-field">
          <label className="ab-label">Priority</label>
          <select name="priority" value={form.priority} onChange={ch} className="ab-input" disabled={submitted}>
            {['Low', 'Medium', 'High', 'Critical'].map(v => <option key={v}>{v}</option>)}
          </select>
        </div>
        <div className="ab-field">
          <label className="ab-label">Amount</label>
          <input name="amount" type="number" step="0.01" value={form.amount} onChange={ch}
            className={`ab-input${errors.amount ? ' ab-input-err' : ''}`} placeholder="0.00" disabled={submitted} />
          {errors.amount && <span className="ab-field-err">{errors.amount}</span>}
        </div>
        <div className="ab-field">
          <label className="ab-label">Currency</label>
          <select name="currency" value={form.currency} onChange={ch} className="ab-input" disabled={submitted}>
            {['INR', 'USD', 'EUR', 'GBP', 'AED', 'SGD'].map(v => <option key={v}>{v}</option>)}
          </select>
        </div>
        <div className="ab-field">
          <label className="ab-label">Date</label>
          <input name="date" type="date" value={form.date} onChange={ch}
            className={`ab-input${errors.date ? ' ab-input-err' : ''}`} disabled={submitted} />
          {errors.date && <span className="ab-field-err">{errors.date}</span>}
        </div>
        <div className="ab-field">
          <label className="ab-label">Project Code</label>
          <input name="projectCode" value={form.projectCode} onChange={ch}
            className={`ab-input${errors.projectCode ? ' ab-input-err' : ''}`} placeholder="PRJ-XXXX-XX" disabled={submitted} />
          {errors.projectCode && <span className="ab-field-err">{errors.projectCode}</span>}
        </div>
      </div>
      <div className="ab-field">
        <label className="ab-label">Notes</label>
        <textarea name="notes" value={form.notes} onChange={ch} rows={2}
          className={`ab-input ab-textarea${errors.notes ? ' ab-input-err' : ''}`}
          placeholder="Describe the expense..." disabled={submitted} />
        {errors.notes && <span className="ab-field-err">{errors.notes}</span>}
      </div>
      <div className="ab-checkboxes-row">
        <Chk name="billable" label="Billable to Client" checked={form.billable} onChange={ch} disabled={submitted} />
        <Chk name="reimbursable" label="Reimbursable" checked={form.reimbursable} onChange={ch} disabled={submitted} />
        <Chk name="receiptAttached" label="Receipt Attached" checked={form.receiptAttached} onChange={ch} disabled={submitted} />
      </div>
      {!submitted
        ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Report</button>
        : <div className="ab-submitted-badge">✓ Report Submitted — Evaluating...</div>
      }
    </div>
  );
}
